@if (showScanner()) {
  <div class="scanner-wrapper">
    <h2>Apunta la cámara al código QR de la mesa</h2>

    <zxing-scanner
      (scanSuccess)="onScanSuccess($event)"
      (scanError)="onScanError($event)"
      [enable]="true"
    ></zxing-scanner>

    <button class="cancel-btn" (click)="cancelScan()">Cancelar</button>
  </div>
} @else if (processing()) {
  <div class="processing-state">
    <div class="spinner"></div>
    <p>Validando acceso...</p>
  </div>
}
